import styled from "styled-components";
import { FormControl } from "@mui/material";

export const FormGroupSection = styled(FormControl)`
  display: block;

  /* margin-bottom: 30px; */
`;
